import { getTone } from "../utils/palette";

function getStatusTone(status) {
  return {
    paid: "green",
    pending: "amber",
    cancelled: "red",
    refunded: "red",
  }[status] ?? "grey";
}

export default function Chip({ className = "", children, status }) {
  const tone = getStatusTone(status);

  return (
    <span
      className={`
        inline-flex items-center capitalize rounded-md border border-[var(--tone)] bg-[var(--tone)] px-2 text-sm
        ${tone === "grey" ? "text-gray-700" : "text-white"}
        ${getTone(tone)}
        ${className}
      `}
    >
      {children ?? status}
    </span>
  );
}